import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, vShow as _vShow, withDirectives as _withDirectives, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "header" }
const _hoisted_2 = { class: "title" }
const _hoisted_3 = {
  class: "applicant-info",
  id: "student"
}
const _hoisted_4 = { class: "info-section" }
const _hoisted_5 = { class: "info" }
const _hoisted_6 = { class: "info-section" }
const _hoisted_7 = { class: "info" }
const _hoisted_8 = {
  class: "section",
  id: "student-information-collapsible"
}
const _hoisted_9 = { class: "info-title" }
const _hoisted_10 = { class: "info" }

import { computed, watch, ref } from "vue";
import { useStore } from "vuex";
import Tile from "@/components/shared/Tile.vue";
import Loader from "@/components/shared/Loader.vue";
import { FormModes } from "@/models/form";
import useApplicationInfo from "@/composables/application-info/useApplicationInfo";
import { StudentVM, StudentDto } from "@/models/student";
import Icon from "@/components/shared/Icon.vue";
import StudentInformationModal from "@/components/application-info/parent-loc/student/StudentInformationModal.vue";
import {
  NationalIdNumberTypeDefinitions,
  NationalIdNumberTypeIds,
} from "@/models/nationalIdNumberTypes";
import CollapsibleSection from "@/components/transitions/CollapsibleSection.vue";
import ModalFade from "@/components/transitions/ModalFade.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'StudentInformation',
  props: {
    loading: { type: Boolean },
    disabled: { type: Boolean },
    student: {}
  },
  emits: ["studentUpdated"],
  setup(__props: any, { emit: __emit }) {

const store = useStore();

const props = __props;

const emit = __emit;

const {
  editable,
  handleStudentInformation,
  openStudentInformationModal,
  closeStudentInformationModal,
} = useApplicationInfo();

const mode = ref<keyof typeof FormModes>(FormModes.view);

const showDetails = ref<boolean>(false);

const showStudentInformationModal = computed<boolean>(
  () => store.state.applicationInfoModule.studentInformationModalActive,
);

const details = computed(() => {
  return [
    {
      key: "addressDisplay",
      label: "Address",
      value: props.student?.addressDisplay,
      width: "col-12",
    },
    {
      key: "nationalIdNumber",
      label:
        NationalIdNumberTypeDefinitions[
          props.student?.nationalIdNumberTypeId || NationalIdNumberTypeIds.SSN
        ]?.abbreviation,
      value: props.student?.nationalIdNumber,
      width: "col-sm-12 col-md-12 col-lg-6 col-6",
    },
    {
      key: "citizenshipStatusTypeName",
      label: "Citizenship",
      value: props.student?.citizenshipStatusName,
      width: "col-6",
    },
    {
      key: "citizenshipStatusTypeName",
      label: "Parent/Guardian Attestation",
      value: props.student?.parentAttestation?.consentGiven ? "Attested" : "N/A",
      width: "col-12",
    },
  ];
});

function changeMode(newMode: keyof typeof FormModes) {
  mode.value = newMode;
}
function handleClose() {
  changeMode(FormModes.view);
  closeStudentInformationModal();
}
function handleEditClick() {
  changeMode(FormModes.edit);
  openStudentInformationModal();
}

async function onStudentUpdated(student: StudentVM) {
  await handleStudentInformation(student);
  changeMode(FormModes.view);
  emit("studentUpdated", student);
}

watch(
  () => mode.value,
  (newVal, oldVal) => {
    if (newVal === FormModes.edit) {
      openStudentInformationModal();
    }
  },
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(Tile, null, {
      default: _withCtx(() => [
        (__props.loading)
          ? (_openBlock(), _createBlock(Loader, { key: 0 }))
          : _createCommentVNode("", true),
        _withDirectives(_createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("p", _hoisted_2, [
              _cache[2] || (_cache[2] = _createTextVNode(" Student Information ", -1)),
              (!__props.loading && _unref(editable))
                ? (_openBlock(), _createElementBlock("a", {
                    key: 0,
                    href: undefined,
                    class: "edit-link",
                    onClick: handleEditClick
                  }, "Edit"))
                : _createCommentVNode("", true)
            ])
          ]),
          _createVNode(Icon, {
            class: "toggle",
            icon: showDetails.value ? 'chevron-up' : 'chevron-down',
            onClick: _cache[0] || (_cache[0] = ($event: any) => (showDetails.value = !showDetails.value))
          }, null, 8, ["icon"]),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", {
              class: _normalizeClass(["section", __props.loading ? 'hide' : '']),
              id: "student-information"
            }, [
              _createElementVNode("div", _hoisted_4, [
                _cache[3] || (_cache[3] = _createElementVNode("p", { class: "info-title" }, "Name", -1)),
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("p", null, _toDisplayString(__props.student?.fullName), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_6, [
                _cache[4] || (_cache[4] = _createElementVNode("p", { class: "info-title" }, "DOB", -1)),
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("p", null, _toDisplayString(__props.student?.dateOfBirthDisplay), 1)
                ])
              ])
            ], 2),
            _createVNode(CollapsibleSection, {
              inverted: showDetails.value === true,
              isVisible: showDetails.value,
              onToggle: _cache[1] || (_cache[1] = ($event: any) => (showDetails.value = !showDetails.value))
            }, {
              default: _withCtx(() => [
                _withDirectives(_createElementVNode("div", _hoisted_8, [
                  _cache[5] || (_cache[5] = _createElementVNode("div", { class: "info-sections" }, null, -1)),
                  _cache[6] || (_cache[6] = _createElementVNode("div", { class: "info-sections" }, null, -1)),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(details.value, (detail, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: _normalizeClass(["info-section", detail.width]),
                      key: index
                    }, [
                      _createElementVNode("p", _hoisted_9, _toDisplayString(detail?.label), 1),
                      _createElementVNode("div", _hoisted_10, [
                        _createElementVNode("p", null, _toDisplayString(detail?.value), 1)
                      ])
                    ], 2))
                  }), 128))
                ], 512), [
                  [_vShow, showDetails.value]
                ])
              ]),
              _: 1
            }, 8, ["inverted", "isVisible"])
          ])
        ], 512), [
          [_vShow, !__props.loading]
        ])
      ]),
      _: 1
    }),
    _createVNode(ModalFade, { isVisible: showStudentInformationModal.value }, {
      default: _withCtx(() => [
        (showStudentInformationModal.value)
          ? (_openBlock(), _createBlock(StudentInformationModal, {
              key: 0,
              loading: __props.loading,
              disabled: __props.disabled,
              student: __props.student,
              onStudentUpdated: onStudentUpdated,
              onClose: handleClose
            }, null, 8, ["loading", "disabled", "student"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["isVisible"])
  ], 64))
}
}

})